import * as Icons from "@mui/icons-material";

const {
  Search: SearchIcon,
  Settings: SettingsIcon,
  Logout: LogoutIcon,
  ArrowDropDown: ArrowDropDownIcon,
  ArrowDropUp: ArrowDropUpIcon,
  Cloud: CloudIcon,
  Image: ImageIcon,
  Folder: FolderIcon,
  Add: AddIcon,
  Remove: RemoveIcon,
  DragIndicator: DragIndicatorIcon,
  PushPin: PushPinIcon,
  Menu: MenuIcon,
  ArrowBack: ArrowBackIcon,
  Close: CloseIcon,
  UnfoldMoreRounded: UnfoldMoreRoundedIcon,
  Edit: EditIcon,
  AllInbox: AllInboxIcon,
  Keyboard: KeyboardIcon,
  MoreHoriz: MoreHorizIcon,
  ModelTraining: ModelTrainingIcon,
  ChevronRight: ChevronRightIcon,
  Info: InfoIcon,
  Check: CheckIcon,
  Delete: DeleteIcon,
  MoreVert: MoreVertIcon,
  Upload: UploadIcon,
  List: ListIcon,
  Preview: PreviewIcon,
  Print: PrintIcon,
  LightMode: LightModeIcon,
  Contrast: ContrastIcon,
  ColorLens: ColorLensIcon,
  BlurLinear: BlurLinearIcon,
  FormatColorFill: FormatColorFillIcon,
  Crop32: Crop32Icon,
  PanoramaFishEye: PanoramaFishEyeIcon,
  ChangeHistory: ChangeHistoryIcon,
  OpenInNew: OpenInNewIcon,
  OpenInBrowser: OpenInBrowserIcon,
  FilterList: FilterListIcon,
  SaveAlt: SaveAltIcon,
  SaveAs: SaveAsIcon,
  DriveFolderUpload: DriveFolderUploadIcon,
  Save: SaveIcon,
  FolderOff: FolderOffIcon,
  ManageSearch: ManageSearchIcon,
  RemoveRedEye: RemoveRedEyeIcon,
  VisibilityOff: VisibilityOffIcon,
  PhotoLibrary: PhotoLibraryIcon,
  Category: CategoryIcon,
  TrendingUp: TrendingUpIcon,
  Assessment: AssessmentIcon,
  CheckCircleOutline: CheckCircleOutlineIcon,
  Description: DescriptionIcon,
  Visibility: VisibilityIcon,
  BackupTable: BackupTableIcon,
  CalendarToday: CalendarTodayIcon,
  Cancel: CancelIcon,
  FileOpen: FileOpenIcon,
  NavigateNext: NavigateNextIcon,
  NavigateBefore: NavigateBeforeIcon,
  ExpandCircleDown: ExpandCircleDownIcon,
  ExpandLess: ExpandLessIcon,
  ExpandMore: ExpandMoreIcon,
  BarChart: BarChartIcon,
  Stop: StopIcon,
  Tune: TuneIcon,
  MenuBook: MenuBookIcon,
  InfoOutlined: InfoOutlinedIcon,
  PlayArrow: PlayArrowIcon,
  DriveFileMove: DriveFileMoveIcon,
  AddToDrive: AddToDriveIcon,
  DoneAll: DoneAllIcon,
  FolderOpen: FolderOpenIcon,
  UploadFile: UploadFileIcon,
  GridView: GridViewIcon,
  ViewHeadline: ViewHeadlineIcon,
  Article: ArticleIcon,
  ArrowForwardIos: ArrowForwardIosIcon,
  ArrowBackIos: ArrowBackIosIcon,
  Storage: StorageIcon,
  HelpOutline: HelpOutlineIcon,
  Cached: CachedIcon,
  HourglassBottom: HourglassBottomIcon,
  ArrowUpward: ArrowUpwardIcon,
  ArrowDownward: ArrowDownwardIcon,
  KeyboardArrowUp: KeyboardArrowUpIcon,
  KeyboardArrowDown: KeyboardArrowDownIcon,
  FilterAltOutlined: FilterAltOutlinedIcon,
  DownloadOutlined: DownloadOutlinedIcon,
  ArrowLeft: ArrowLeftIcon,
  ArrowRight: ArrowRightIcon,
  DriveFileRenameOutline: DriveFileRenameOutlineIcon,
  CloudUpload: CloudUploadIcon,
} = Icons;

export {
  SearchIcon,
  SettingsIcon,
  LogoutIcon,
  ArrowDropDownIcon,
  ArrowDropUpIcon,
  CloudIcon,
  ImageIcon,
  FolderIcon,
  AddIcon,
  RemoveIcon,
  DragIndicatorIcon,
  PushPinIcon,
  MenuIcon,
  ArrowBackIcon,
  CloseIcon,
  UnfoldMoreRoundedIcon,
  EditIcon,
  AllInboxIcon,
  KeyboardIcon,
  MoreHorizIcon,
  ModelTrainingIcon,
  ChevronRightIcon,
  InfoIcon,
  CheckIcon,
  DeleteIcon,
  MoreVertIcon,
  UploadIcon,
  ListIcon,
  PreviewIcon,
  PrintIcon,
  LightModeIcon,
  ContrastIcon,
  ColorLensIcon,
  BlurLinearIcon,
  FormatColorFillIcon,
  Crop32Icon,
  PanoramaFishEyeIcon,
  ChangeHistoryIcon,
  OpenInNewIcon,
  OpenInBrowserIcon,
  FilterListIcon,
  SaveAltIcon,
  SaveAsIcon,
  DriveFolderUploadIcon,
  SaveIcon,
  FolderOffIcon,
  ManageSearchIcon,
  RemoveRedEyeIcon,
  VisibilityOffIcon,
  PhotoLibraryIcon,
  CategoryIcon,
  TrendingUpIcon,
  AssessmentIcon,
  CheckCircleOutlineIcon,
  DescriptionIcon,
  VisibilityIcon,
  BackupTableIcon,
  CalendarTodayIcon,
  CancelIcon,
  FileOpenIcon,
  NavigateNextIcon,
  NavigateBeforeIcon,
  ExpandCircleDownIcon,
  ExpandLessIcon,
  ExpandMoreIcon,
  BarChartIcon,
  StopIcon,
  TuneIcon,
  MenuBookIcon,
  InfoOutlinedIcon,
  PlayArrowIcon,
  DriveFileMoveIcon,
  AddToDriveIcon,
  DoneAllIcon,
  FolderOpenIcon,
  UploadFileIcon,
  GridViewIcon,
  ViewHeadlineIcon,
  ArticleIcon,
  ArrowForwardIosIcon,
  ArrowBackIosIcon,
  StorageIcon,
  HelpOutlineIcon,
  CachedIcon,
  HourglassBottomIcon,
  ArrowUpwardIcon,
  ArrowDownwardIcon,
  KeyboardArrowUpIcon,
  KeyboardArrowDownIcon,
  FilterAltOutlinedIcon,
  DownloadOutlinedIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  DriveFileRenameOutlineIcon,
  CloudUploadIcon,
};
